<div class="container">
    <button #focusableEleTop class="focusable-element"></button>
    <div class="row" *ngIf="!isFormValid">
        <div class="col-24" *ngIf="ErrorMessages?.length > 0">
            <div class="alert danger">
                <p><em>Error Message:</em></p>
                <ul>
                    <li *ngFor="let error of ErrorMessages"><button>{{error}}</button></li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="showSuccessMsg">
        <div class="col-24">
            <div class="alert success">
                <p>{{errorConfMsg}}</p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <div class="instructions-list">
                <p><strong>Please update your Cell Phone Number  before continuing:</strong></p>
            </div>
        </div>
    </div>

    <fieldset>
        <legend>Login ID: {{userProfileName}}</legend>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <MaskedValidatedTextField class="field"
                                              [label]="'Cell Phone Number'"
                                              id="cellphoneno"
                                             
                                              [text]="userCellPhoneNo"
                                              (onValueChange)="userCellPhoneNo = $event"
                                              [inputMask]="phoneNumberInputMask"
                                              [validators]="[notBlankValidator,numericValidator,lengthValidator]" maxlength="10">
                    </MaskedValidatedTextField>

                    <!--<MaskedValidatedTextField class="field" [label]="'Long-Term Care Facility Phone'" id="LTC-facility-phone" [text]="LTCFacilityPhone"
                                              [disabled]="disabled" (onValueChange)="onLTCFacilltyPhoneChange.emit($event)"
                                              [maxlength]="10" [inputMask]="phoneNumberInputMask">
                    </MaskedValidatedTextField>-->
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <MaskedValidatedTextField class="field"
                                              [label]="' Confirm Cell Phone Number '"
                                              id="confirmcellphoneno"
                                              fieldId="userConfirmCellPhoneNo"
                                              [text]="userConfirmCellPhoneNo"
                                              (onValueChange)="userConfirmCellPhoneNo = $event"
                                              [inputMask]="phoneNumberInputMask"
                                              [validators]="[notBlankValidator,numericValidator,lengthValidator]" maxlength="10">
                    </MaskedValidatedTextField>

                    <!--<MaskedValidatedTextField class=""
                                              [label]="'Confirm Cell Phone Number'"
                                              id="cellnum"
                                              [text]="cellPhone.Phone"
                                              (onValueChange)="cellPhone.Phone=$event"
                                              [maxlength]="10"
                                              [inputMask]="phoneNumberInputMask"
                                              [validators]="[numericValidator]">
                    </MaskedValidatedTextField>-->
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <button class="button primary" (click)="Save()">Next</button>
            </div>
        </div>
    </fieldset>
</div>



